import {
  SectionElement,
  defineElement
} from "./chunk-POAMU4SL.js";
import {
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/sections/shop-team-slider/shop-team-slider.ts
var ShopTeamSlider = class extends SectionElement {
  /*
    @queryAll('[image-modal]')
    private readonly imageModals?: UtilModal[]
  
    @onClick('[data-modal-open]')
    showModal (elm: HTMLElement) {
      this.imageModals?.find(m => m.dataset.modalIndex === elm.dataset.modalOpen)?.toggle()
    }
  
    @onClick('[data-next-modal]')
    nextModal (elm: HTMLElement) {
      const index = parseInt(elm.dataset.index!)
      this.imageModals?.[index]?.close()
      if (index !== this.imageModals!.length - 1) {
        this.imageModals?.[index + 1]?.toggle()
      } else {
        this.imageModals?.[0]?.toggle()
      }
    }
    */
};
ShopTeamSlider = __decorateClass([
  defineElement("shop-team-slider")
], ShopTeamSlider);
export {
  ShopTeamSlider
};
